import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';

import { Button, TextArea } from '@components/common';

import { IErrorCode, IErrorCodesFormValues } from '@interfaces/errors/apiErrors';

import { ERevalidationMode, EValidationMode } from '@enums/validationMode';

import { schema } from './schema';

import styles from './ErrorCodesEditForm.module.scss';

export type TErrorCodesFormSubmitHandler = (dto: IErrorCodesFormValues) => void;

interface IErrorCodesEditFormProps {
	editableErrorCode: IErrorCode;
	onClose: () => void;
	submitHandler: TErrorCodesFormSubmitHandler;
	setIsDirtyFormModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const ErrorCodesEditForm = ({
	editableErrorCode,
	onClose,
	submitHandler,
	setIsDirtyFormModal,
}: IErrorCodesEditFormProps) => {
	const {
		register,
		handleSubmit,
		formState: { errors, isDirty },
	} = useForm<IErrorCodesFormValues>({
		mode: EValidationMode.all,
		reValidateMode: ERevalidationMode.onChange,
		resolver: yupResolver(schema),
		defaultValues: {
			message: editableErrorCode?.message || '',
		},
	});

	useEffect(() => setIsDirtyFormModal(isDirty), [isDirty, setIsDirtyFormModal]);

	const onSubmit = (dto: IErrorCodesFormValues) => submitHandler({
		...dto,
		id: editableErrorCode?.id,
	});

	return (
		<div>
			<div className={styles.errorCode}>
				{editableErrorCode.code}
			</div>
			<div>
				<TextArea
					errorMessage={errors?.message?.message}
					label='Human-readable Description'
					name='message'
					placeholder='Enter description'
					register={register}
					required
					rows={3}
					withUseForms
				/>
			</div>
			<div className={styles.submitButtons}>
				<Button
					onClick={onClose}
					text='Cancel'
					withoutBackground
				/>
				<Button
					onClick={handleSubmit(onSubmit)}
					text='Save'
				/>
			</div>
		</div>
	);
};

export default ErrorCodesEditForm;
